export const AppRoute = {
  artists: '/artists',
  spotify: '/spotify',
  deezer: '/deezer',
  youtube: '/youtube',
  privacy: '/privacy',
  terms: '/terms',
  home: '/',
};
